export const hasArrayValues = (list) => !!list && Array.isArray(list) && list.length > 0;

export const transformListIntoDictionary = (list, key) => {
  if (!hasArrayValues(list) || !key) {
    return {};
  }
  if (!Object.fromEntries) {
    return list.reduce((acc, item) => {
      if (item[key] !== undefined) {
        acc[item[key]] = item;
      }
      return acc;
    }, {});
  }

  return Object.fromEntries(list.map((item) => [item[key], item]));
};